export default __webpack_public_path__ + "static/media/SEC1350.34I-30005_-17400_0.12ace384.jpg";